import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { GlobalSettings } from '../../shared/domain/configuration.model';

@Component({
  selector: 'cc-ip-exclusion',
  templateUrl: './ip-exclusion.component.html',
  styleUrls: ['./ip-exclusion.component.scss']
})
export class IpExclusionComponent implements OnInit {
  @Input() public formGroup: FormGroup;
  @Input() public globalSettings: GlobalSettings;

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.formGroup.addControl('ipExclusionEnabled', this.fb.control(this.globalSettings.ipExclusionEnabled));
    this.formGroup.addControl('blockedIps', this.prepareBlockedIps());
  }

  prepareBlockedIps() {
    return this.globalSettings.blockedIps && this.globalSettings.blockedIps.length
      ? this.fb.array([...this.globalSettings.blockedIps.map(ipObject => new FormControl(ipObject))])
      : this.fb.array([this.prepareNewInputField()]);
  }

  prepareNewInputField(): FormControl {
    return new FormControl('');
  }

  addNewInputField(): void {
    const control = <FormArray>this.formGroup.controls.blockedIps;
    control.push(this.prepareNewInputField());
  }

  removeInputField(i: number): void {
    const control = <FormArray>this.formGroup.controls.blockedIps;
    control.removeAt(i);
  }

  get isIpExclusionEnabled() {
    return this.formGroup.get('ipExclusionEnabled').value;
  }
}
